import {
  Layout
} from '@/views/layout'
import { defineAsyncComponent } from 'vue'
import { insertItemByOrderProp } from '../../libs/tools'
import { PcRoutes, DashboardSubpages, CorrectAnalRouter, CourseRouter,
  ReportRouter, ArchiveCenterRoute, RespLableRoute, WorkScoreRoute
} from '../../utils/routeData'


const permission = {
  state: {
    roleName: '',
    routes: [], //getLogin请求到的原始路由信息
    addRouters: [], //要添加的路由信息
    defaultRoute: '', //默认路由
    rightObj: {}, //存储各个页面权限详细信息的对象
    pageRightObj: {}, //存储各个页面权限操作信息的对象
    userInfo: null,
  },
  getters: {},
  mutations: {
    SET_ROLE_NAME(state, status) {
      state.roleName = status
    },
    SET_ROUTES(state, status) {
      state.routes = status
    },
    SET_DEFAULT_ROUTE(state, status) {
      state.defaultRoute = status
    },
    SET_ADD_ROUTERS(state, status) {
      state.addRouters = status
    },
    SET_RIGHT_OBJ(state, status) {
      state.rightObj = status
    },
    SET_USER_INFO(state, status) {
      state.userInfo = status
    },
    SET_PAGE_RIGHT_OBJ(state, status) {
      state.pageRightObj = status
    },
  },
  actions: {
    getDynamicMenuRoutes: ({
      commit,
      state
    }, status) => {
      const importVue = async (folder, file) => {
        console.log(`import ${folder}/${file}.vue`)
        try {
          return await import(`../../views/${folder}/${file}.vue`)
        } catch (e) {
          console.warn(e.message)
          return null
        }
      }
      const pushRoute = (arr, parent, route) => {
        rightObj[route.route] = route
        pageRightObj[route.route] = route.children
        //如果时默认页面重定向
        arr[0].children.push({
          path: route.route,
          name: route.route,
          component: defineAsyncComponent(async () => {
            const path = route.path ? route.path : parent.route
            const mod = await importVue(path, route.route)
            return mod ? mod : await importVue(route.route, route.route)
          }),
          meta: {
            tag1: route.rootLable ? route.rootLable : parent.label,
            tag2: route.rootLable ? parent.label : (route.type !== 0 ? route.label : ''),
            tag3: route.rootLable ? route.label : ''
          }
        })
      }
      const addItemToArray = (arr, parent, item) => {
          //类型 0含有子菜单的菜单 1文件夹 2菜单 3按钮
          [0, 2].includes(item.type) && pushRoute(arr, parent ? parent : item, item)
          //若有次级页面直接添加
          Array.isArray(item.subpages) && item.subpages.forEach(sp => pushRoute(arr, item, sp))
          //子节点递归调用
          Array.isArray(item.children) && item.children.forEach(child => addItemToArray(arr, item, child))
      }
      let rightObj = {}
      let pageRightObj = {}
      let reportPerm = false
      status.pcMenus.forEach(item => {
        if (item.menuId === WorkScoreRoute.menuId) {//工分菜单
          item.route = WorkScoreRoute.route
          item.children = WorkScoreRoute.children
        } else if (item.menuId === ReportRouter.menuId) {//报表菜单
          reportPerm = true;
          //若培训模块已开启, 将课程报表子节点加入报表菜单
          if (status.trainingModuleEnable) {
            ReportRouter.children.forEach(r => insertItemByOrderProp(item.children, r))
          }
          //数组的最后加入归档中心页面
          item.children.push(ArchiveCenterRoute)
        } else if (item.route === PcRoutes.Dashboard) {//看板
          item.subpages = DashboardSubpages
          Array.isArray(item.children)
            && item.children.some(m => m.route === PcRoutes.EvaAnal)
            && insertItemByOrderProp(item.children, CorrectAnalRouter)
        } else if (item.route === PcRoutes.Assess) {//任务模板管理
          Array.isArray(item.children)
            && item.children.some(m => m.route === PcRoutes.TaskTpl)
            && item.children.push(RespLableRoute)
        }
      })
      // 若用户开启培训模块权限
      if (status.trainingModuleEnable) {
        // 将课程管理菜单插入到指定位置
        insertItemByOrderProp(status.pcMenus, CourseRouter)
        // 若报表菜单不存在，插入整个节点
        reportPerm || insertItemByOrderProp(status.pcMenus, ReportRouter)
      }
      commit('SET_USER_INFO', status)
      commit('SET_ROLE_NAME', status.name)
      // commit('SET_ROUTES', [...status.pcMenus, ...demo])
      commit('SET_ROUTES', status.pcMenus)

      commit('SET_ADD_ROUTERS',
        state.routes.reduce((arr, item) => {
          addItemToArray(arr, null, item)
          return arr
        }, [{
          path: '/',
          component: Layout,
          children: []
        }])
      )
      let defaultRoute = state.addRouters[0].children[0].path
      if (defaultRoute) {
        commit('SET_DEFAULT_ROUTE', defaultRoute)
      }
      commit('SET_RIGHT_OBJ', rightObj)
      commit('SET_PAGE_RIGHT_OBJ', pageRightObj)
    }
  }
}
export default permission
